import React from 'react'
import Esther_Wanjiku_profile from "../../Assets/Esther_Wanjiku_profile.jpg"
function AboutMe() {
  return (
    <section id='AboutMe' className='about--section grid grid-cols-1 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 space-x-3 mt-4'>
        <div className='about--section--img w-full h-full flex items-center justify-center'>
          <img src="https://avatars.githubusercontent.com/u/152400135?v=4" alt='about me' className='w-full sm:w-full md:w-[90%] lg:w-[70%] rounded-lg'/>
        </div>
        <div className='hero--section--content--box about--section--box'>
          <div className='hero--section--content'>
            <h1 className='skills--section--heading'>
                About Me
            </h1>
            <p className='hero--section--description'>
            I am a passionate software developer  with experience in making user applications that are up to bit with the latest design requirements ,always ready to enhance and improve user experience and create great an outstnding applications                
            driven by a mission to leverage technology to improve lives and create a positive impact in society. With a focus on innovative solutions, I aim to build tools and applications that make a meaningful difference in the world.
            </p>
            
          </div>
        </div>
     </section> 
  )
}

export default AboutMe